// extracted by mini-css-extract-plugin
export default {"UpcomingInvoices":"UpcomingInvoices_UpcomingInvoices__iNkJ1"};